export default "__VITE_ASSET__DggQrk0p__"